<template>
  <v-toolbar flat color="primary" dark>
    <v-list>
      <v-list-tile @click="navigate">
        <v-list-tile-title class="title">Administration</v-list-tile-title>
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ListGroupAdmin',
  methods: {
    navigate() {
      window.location.href = process.env.ADMIN;
    },
  },
};
</script>
